type ClaimsUrls = {
  canSomeoneFileAnAppealForMe: string
  claimDeductible: string
  costsAtAGlance: string
  coverage: string
  editCommunicationSettings: string
  fiveThingsToKnowWhenFilingAnAppeal: string
  formsHelpMsn: string
  getHelpPayingCosts: string
  howOriginalMedicareWorks: string
  howToFileAClaim: string
  howToFileAComplaint: string
  howToFileAnAppeal: string
  howToSpotFraud: string
  msaDisclaimer: string
  mspDisclaimer: string
  ccxpQualityLink: string
}

export const CLAIMS_URLS_ENGLISH: ClaimsUrls = {
  canSomeoneFileAnAppealForMe: 'https://www.medicare.gov/claims-appeals/file-an-appeal/can-someone-file-an-appeal-for-me',
  claimDeductible: 'https://www.medicare.gov/mbp/claimdeductible.aspx?Lang=en-us',
  costsAtAGlance: 'https://www.medicare.gov/your-medicare-costs/medicare-costs-at-a-glance',
  coverage: 'https://www.medicare.gov/coverage',
  editCommunicationSettings: 'https://www.medicare.gov/mbp/editcommunicationsettings.aspx?Lang=en-us',
  fiveThingsToKnowWhenFilingAnAppeal: 'https://www.medicare.gov/claims-appeals/file-an-appeal/5-things-to-know-when-filing-an-appeal',
  formsHelpMsn: 'https://www.medicare.gov/forms-help-resources/mail-you-get-about-medicare/medicare-summary-notice-msn',
  getHelpPayingCosts: 'https://www.medicare.gov/your-medicare-costs/get-help-paying-costs',
  howOriginalMedicareWorks: 'https://www.medicare.gov/what-medicare-covers/your-medicare-coverage-choices/how-original-medicare-works',
  howToFileAClaim: 'https://www.medicare.gov/claims-appeals/how-do-i-file-a-claim',
  howToFileAComplaint: 'https://www.medicare.gov/claims-appeals/how-to-file-a-complaint-grievance',
  howToFileAnAppeal: 'https://www.medicare.gov/claims-appeals/how-do-i-file-an-appeal',
  howToSpotFraud: 'https://www.medicare.gov/forms-help-resources/help-fight-medicare-fraud/how-spot-medicare-fraud',
  msaDisclaimer: 'https://www.medicare.gov/mbp/msadisclaimer.aspx?Lang=en-us',
  mspDisclaimer: 'https://www.medicare.gov/mbp/mspdisclaimer.aspx?Lang=en-us',
  ccxpQualityLink: 'https://www.medicare.gov/care-compare/oauth'
}

export const CLAIMS_URLS_SPANISH: ClaimsUrls = {
  canSomeoneFileAnAppealForMe: 'https://es.medicare.gov/claims-appeals/file-an-appeal/can-someone-file-an-appeal-for-me',
  claimDeductible: 'https://www.medicare.gov/mbp/claimdeductible.aspx?lang=es-mx',
  costsAtAGlance: 'https://es.medicare.gov/your-medicare-costs/medicare-costs-at-a-glance',
  coverage: 'https://es.medicare.gov/coverage',
  editCommunicationSettings: 'https://www.medicare.gov/mbp/editcommunicationsettings.aspx?Lang=es-mx',
  fiveThingsToKnowWhenFilingAnAppeal: 'https://es.medicare.gov/claims-appeals/file-an-appeal/5-things-to-know-when-filing-an-appeal',
  formsHelpMsn: 'https://es.medicare.gov/forms-help-resources/mail-you-get-about-medicare/medicare-summary-notice-msn',
  getHelpPayingCosts: 'https://es.medicare.gov/your-medicare-costs/get-help-paying-costs',
  howOriginalMedicareWorks: 'https://es.medicare.gov/what-medicare-covers/your-medicare-coverage-choices/how-original-medicare-works',
  howToFileAClaim: 'https://es.medicare.gov/claims-appeals/how-do-i-file-a-claim',
  howToFileAComplaint: 'https://es.medicare.gov/claims-appeals/how-to-file-a-complaint-grievance',
  howToFileAnAppeal: 'https://es.medicare.gov/claims-appeals/how-do-i-file-an-appeal',
  howToSpotFraud: 'https://es.medicare.gov/forms-help-resources/help-fight-medicare-fraud/how-spot-medicare-fraud',
  msaDisclaimer: 'https://www.medicare.gov/mbp/msadisclaimer.aspx?Lang=es-mx',
  mspDisclaimer: 'https://www.medicare.gov/mbp/mspdisclaimer.aspx?Lang=es-mx',
  ccxpQualityLink: 'https://es.medicare.gov/care-compare/oauth'
}
